export interface City {
  Name: string;
}

export  class Station {
  public Id: number;
  public Name: string;
  public Address: string;
  public Phone: string;
  public CityName: string;
  public X: string;
  public Y: string;
  public lat: number;
  public lng: number;
  public Distance?: number;
}
export class  StationDetails
{
  Id: number;
  Name: string;
  Address: string;
  Phone: string;
  Fax: string;
  Mail: string;
  FirstName: string;
  LastName: string;
  Darga: string;
  X: string;
  Y: string;
  Img: string;

}

